import styles from './MediaItem.module.scss';
import { UI_Player } from 'ui/components/1-atoms/Media/Player/Player';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { useInView } from 'react-intersection-observer';

export interface UI_MediaItemProps {
	className?: string;
	image?: {
		url: string;
		altText?: string;
		focalPoint?: { left: number; top: number };
		imageCropping?: 'cover' | 'contain';
		fileType?: string;
	};
	video?: {
		url: string;
		poster?: string;
		autoplay?: boolean;
		showControls?: boolean;
		isMuted?: boolean;
	};
	sizes?: string;
}

export const UI_MediaItem: React.FC<UI_MediaItemProps> = ({ image, video, sizes }) => {
	const { ref, inView } = useInView({
		threshold: 0.5,
		triggerOnce: false,
	});
	return (
		<div ref={ref} className={styles.MediaItem}>
			{video ? (
				<UI_Player
					url={video.url}
					isLight={video.autoplay || (inView && video.autoplay) ? false : true}
					playing={inView ? true : false}
					muted={video.isMuted}
					loop={true}
					controls={video.showControls}
					poster={image?.url}
					cover={true}
				/>
			) : (
				image && (
					<UI_Picture
						url={image.url}
						altText={image.altText}
						focalPoint={image.focalPoint}
						imageCropping={image.imageCropping ?? 'cover'}
						sizes={sizes}
						fileType={image.fileType}
					/>
				)
			)}
		</div>
	);
};
